import {
  ActionIcon,
  Group,
  NumberInput,
  TextInput,
  Tooltip,
} from "@mantine/core";
import React, { useEffect } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { IconPlus, IconTrash } from "@tabler/icons-react";

let linkId = 1;
const ScoreLinkSpecific = ({ links, setLinks }) => {
  const lang = useLanguage((s) => s.language);
  const addLink = () => {
    setLinks((prev) => [...prev, { key: "", value: "", id: linkId++ }]);
  };

  const removeLink = (id) => {
    if (links.length === 1) {
      setLinks([
        {
          key: "",
          value: null,
          id: linkId++,
        },
      ]);
    } else {
      setLinks((prev) => {
        let newHeaders = [...prev];

        return newHeaders.filter((x) => x.id !== id);
      });
    }
  };

  const editLink = (index, field, newValue) => {
    setLinks((prev) => {
      let newHeaders = [...prev];
      newHeaders[index][field] = newValue;

      return newHeaders;
    });
  };

  useEffect(() => {
    linkId = links.length + 1;
  }, []);

  return links.map((link, index) => (
    <Group key={link.id} align="end" w={"100%"} wrap="nowrap" mt={4} gap={"lg"}>
      <TextInput
        label={index === 0 ? "URL" : null}
        placeholder="https://..."
        w={"100%"}
        value={link.key}
        onChange={(e) => editLink(index, "key", e.target.value)}
        size="md"
        type="url"
        required={links.length === 1 ? links[0].value : links.length !== 1}
        title={`${lang.webhooks.create.authorized_chars} ' # $ % & * + . ^ _ | ~ ! -`}
      />
      <NumberInput
        label={index === 0 ? lang.prm.scoring.score : null}
        placeholder={lang.prm.scoring.score}
        w={"100%"}
        value={link.value}
        onChange={(v) => editLink(index, "value", v)}
        size="md"
        required={links.length === 1 ? links[0].key : links.length !== 1}
        min={-32767}
        max={32767}
      />
      {((links.length === 1 && links[0]?.key) || links.length > 1) && (
        <Tooltip label={lang.prm.scoring.delete_link}>
          <ActionIcon
            size={42}
            color="red"
            variant="light"
            onClick={() => removeLink(link.id)}
          >
            <IconTrash size={18} />
          </ActionIcon>
        </Tooltip>
      )}

      <Tooltip label={lang.prm.scoring.add_link}>
        <ActionIcon
          size={42}
          color="tertiary.8"
          variant="light"
          style={{
            visibility: index < links.length - 1 ? "hidden" : "visible",
          }}
          onClick={addLink}
        >
          <IconPlus size={18} />
        </ActionIcon>
      </Tooltip>
    </Group>
  ));
};

export default ScoreLinkSpecific;
